import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css'

// 全局初始化事件总线
Vue.prototype.$bus = new Vue();



Vue.use(ElementUI,Antd);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
